<template>
  <div class="card is-height-70p">
    <gmap-map
      :center="centerDefault"
      :zoom="zoomDefault"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      class="googleMap"
      id="mapGroupe"
      ref="mapCartoGeneralGroupe"
      @zoom_changed="getZoom = $event">

      <!-- Marker point de vente -->
      <gmap-marker
        v-for="(markerPdv, i) in filtrePdvs"
        :key="'pdv'+i"
        :position="markerPdv.adresse.coordonnees"
        :icon="getIconPdv(markerPdv.icon)"
        @click="accessRecom(markerPdv.previewLink)">
      </gmap-marker>

      <gmap-cluster :minimumClusterSize="7">
        <!-- Marker panneau -->
        <gmap-marker
          v-for="(markerPan, i) in filtrePanneaux"
          :key="'pan'+i"
          :position="markerPan.adresse.coordonnees"
          :icon="getIconPanneau(markerPan)">
        </gmap-marker>
      </gmap-cluster>
      
    </gmap-map>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { CENTER_DEFAULT, ZOOM_DEFAULT,
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/gestionIconMarker/iconColorGetter';
import siteConfig from '@/configurations/siteConfig';

const User = createNamespacedHelpers('user');
const Groupe = createNamespacedHelpers('groupe');

export default {
  props: {},
  data() {
    return {
      isLoadOnce: false,
      centerDefault: CENTER_DEFAULT,
      zoomDefault: ZOOM_DEFAULT,
      getZoom: 0,
      isLoading: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  watch: {
    async filtrePdvs(val) {
      if (!val.length) return;
      await this.levelZoom();
    },
  },
  computed: {
    ...Groupe.mapState({
      pointDeVentes: 'pointDeVentes',
      panneaux: 'panneaux',
    }),
    ...User.mapGetters({
      site: 'site',
    }),
    filtrePdvs() {
      if (!this.pointDeVentes.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.pointDeVentes.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.pointDeVentes;
    },
    filtrePanneaux() {
      if (!this.panneaux.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.panneaux.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.panneaux;
    }
  },
  methods: {
    getIconPdv(url) {
      const { getGoogleAnchor, widthIcon } = (siteConfig[this.site] || siteConfig.default).pdv;
      let srcUrl = require('@/assets/images/icon_marker/marker_default_pdv.png');
      let height = 30;
      let width = 30;
      if (url.includes('data:image')) {
        srcUrl = url;
        width = widthIcon - 5;
        height = widthIcon;
      }
      return {
        url: srcUrl,
        scaledSize: new google.maps.Size(width, height),
        origin: new google.maps.Point(0, 0),
        anchor: getGoogleAnchor(height, width),
      };
    },
    getIconPanneau(panneau) {
      return iconColorGetter(panneau.couleur, TAILLE_ICON_GRAND, panneau.azimut, true);
    },
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      this.filtrePdvs.forEach(el => {
        bounds.extend(el.adresse.coordonnees);
      });
      this.filtrePanneaux.forEach(el => {
        bounds.extend(el.adresse.coordonnees);
      });
      this.$refs.mapCartoGeneralGroupe.fitBounds(bounds);
    },
    accessRecom(lien){
      window.open(lien);
    }
  },
  async mounted() {
    const map = await this.$refs.mapCartoGeneralGroupe.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
  },
};
</script>
